document.addEventListener("DOMContentLoaded", function () {
  const headerWrap = document.querySelector(".au-header-wrapper--hidden");

  // GSAPを使用してアニメーションを設定
  gsap.to(headerWrap, {
    delay: 0.1, // 1秒後に開始
    opacity: 1, // 不透明度を1に設定（表示）
    visibility: "visible", // visibilityをvisibleに設定
    duration: 0.01, // アニメーションの時間（秒）
  });
  //一つひとつに対する要素
  // const boxes = document.querySelectorAll('.box, .box2');
  gsap.utils
    .toArray(".special__content p, .special__content h2, .special-carousel")
    .forEach((text) => {
      gsap.fromTo(
        text,
        { autoAlpha: 0, y: 20 },
        {
          autoAlpha: 1,
          y: 0,
          ease: "none",
          duration: 0.6,
          scrollTrigger: {
            trigger: text,
            start: "top, 81%",
          },
        }
      );
    });
  gsap.utils.toArray(".special__content img").forEach((text) => {
    gsap.fromTo(
      text,
      { autoAlpha: 0, y: 20 },
      {
        autoAlpha: 1,
        y: 0,
        ease: "none",
        duration: 0.6,
        scrollTrigger: {
          trigger: text,
          start: "top, 70%",
        },
      }
    );
  });

  // // 特集ページのヘッダーアニメーション
  // // ヘッダー要素の取得
  // const header = document.querySelector(".header--visible");
  // // メインビジュアル要素の取得
  // const mainVisual = document.querySelector(".feature-section");
  // // gsapを使用してヘッダーの表示/非表示を制御
  // gsap.set(header, { opacity: 0, position: 'fixed', top: 0, left: 0, right: 0, display: 'block' }); // 最初は非表示
  // // メインビジュアルが画面上に入ってきたらヘッダーをフワッと表示
  // ScrollTrigger.create({
  //   trigger: mainVisual,
  //   start: "top center",
  //   onEnter: () => gsap.to(header, {display: 'none', opacity: 0, duration: 0.5 }),
  //   onLeave: () => gsap.to(header, {display: 'block', opacity: 1, duration: 0.5 }),
  //   onEnterBack: () => gsap.to(header, {display: 'none', opacity: 0, duration: 0.5 }),
  //   onLeaveBack: () => gsap.to(header, {display: 'block', opacity: 1, duration: 0.5 }),
  // });
});

// ヘッダーの要素を取得
const headerWrapper = document.querySelector(".header-wrapper");

// 現在のページ URL を取得
const currentPageURL = window.location.pathname;

// トップページまたは特集ページの場合に .is-fixed クラスを追加
//  if (currentPageURL === '/' || currentPageURL === '/pages/feature') {
//    headerWrapper.classList.add('is-fixed');
//  }
if (currentPageURL === "/pages/feature" || currentPageURL === "/pages/xx") {
  // feature-videoクラスの要素を監視
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        // feature-videoクラスの要素が表示されているかチェック
        if (entry.isIntersecting) {
          // au-header-wrapperクラスの要素を非表示にする
          document.querySelector(".au-header-wrapper").style.display = "none";
        } else {
          // feature-videoクラスの要素が表示されていない場合は、au-header-wrapperクラスの要素を表示する
          document.querySelector(".au-header-wrapper").style.display = "";
        }
      });
    },
    { threshold: 0.5 }
  ); // 閾値を0.5に設定して、要素が画面の半分以上表示されているかどうかを確認

  // feature-videoクラスの要素を監視する
  var targetElement = document.querySelector(".feature-video");
  if (targetElement) {
    observer.observe(targetElement);
  }
}

// ヘッダー要素を取得
// const headerItems = document.querySelectorAll('.au-list-menu__item');
// const headerItems02 = document.querySelectorAll('.au-header-wrapper');
// const headerItems03 = document.querySelectorAll('.header-wrapper');
// const headerItems04 = document.querySelectorAll('.au-count-bubble');
// const headerItems05 = document.querySelectorAll('.au-count-bubble span');
// const headerItems06 = document.querySelectorAll('.au-header-wrapper--fixed');
// const headerItems07 = document.querySelectorAll('.au-bar-fixed');
// const bar = document.querySelectorAll('.au-bar');

// スクロールの現在位置を取得
// const scrollY = window.scrollY;

// 特定のページでのみ実行
// if (currentPageURL === '/' || currentPageURL === '/pages/feature') {
//   if (scrollY > 200) {
//     headerItems.forEach(item => item.classList.remove('is-white'));
//     headerItems02.forEach(item => item.classList.remove('is-white-bg'));
//     headerItems03.forEach(item => item.classList.remove('is-color'));
//     headerItems04.forEach(item => item.classList.remove('is-white-bubble'));
//     headerItems05.forEach(item => item.classList.remove('is-black-bubble'));
//     headerItems06.forEach(item => item.classList.remove('is-header-fixed'));
//     headerItems07.forEach(item => item.classList.remove('is-bar-fixed'));
//     bar.forEach(item => item.classList.remove('is-bar'));
//     bar.forEach(item => item.classList.add('is-bar-none'));
//   } else {
//     headerItems.forEach(item => item.classList.add('is-white'));
//     headerItems02.forEach(item => item.classList.add('is-white-bg'));
//     headerItems03.forEach(item => item.classList.add('is-color'));
//     headerItems04.forEach(item => item.classList.add('is-white-bubble'));
//     headerItems05.forEach(item => item.classList.add('is-black-bubble'));
//     headerItems06.forEach(item => item.classList.add('is-header-fixed'));
//     headerItems07.forEach(item => item.classList.add('is-bar-fixed'));
//     bar.forEach(item => item.classList.add('is-bar'));
//     bar.forEach(item => item.classList.remove('is-bar-none'));
//   }
// }

// window.addEventListener('scroll', function () {
//   // スクロールの現在位置を取得
//   const scrollY = window.scrollY;

//   // 特定のページでのみ実行
//   if (currentPageURL === '/' || currentPageURL === '/pages/feature') {
//     if (scrollY > 100) {
//       headerItems.forEach(item => item.classList.remove('is-white'));
//       headerItems02.forEach(item => item.classList.remove('is-white-bg'));
//       headerItems03.forEach(item => item.classList.remove('is-color'));
//       headerItems04.forEach(item => item.classList.remove('is-white-bubble'));
//       headerItems05.forEach(item => item.classList.remove('is-black-bubble'));
//       headerItems06.forEach(item => item.classList.remove('is-header-fixed'));
//       bar.forEach(item => item.classList.remove('is-bar'));
//       bar.forEach(item => item.classList.add('is-bar-none'));
//     } else {
//       headerItems.forEach(item => item.classList.add('is-white'));
//       headerItems02.forEach(item => item.classList.add('is-white-bg'));
//       headerItems03.forEach(item => item.classList.add('is-color'));
//       headerItems04.forEach(item => item.classList.add('is-white-bubble'));
//       headerItems05.forEach(item => item.classList.add('is-black-bubble'));
//       headerItems06.forEach(item => item.classList.add('is-header-fixed'));
//       bar.forEach(item => item.classList.add('is-bar'));
//       bar.forEach(item => item.classList.remove('is-bar-none'));
//     }
//   }
// });

// ボタン要素と回答要素の参照を取得
const questionButtons = document.querySelectorAll(".Faq__Question");
const answerWrappers = document.querySelectorAll(".Faq__AnswerWrapper");
const faqIcons = document.querySelectorAll(".Faq__Icon");

// 各ボタンにクリックイベントリスナーを追加
questionButtons.forEach((questionButton, index) => {
  questionButton.addEventListener("click", function () {
    // 対応する回答要素にis-openクラスを追加または削除
    if (answerWrappers[index].classList.contains("is-open")) {
      answerWrappers[index].classList.remove("is-open");
    } else {
      answerWrappers[index].classList.add("is-open");
    }
    // 対応するアイコンにis-rotateクラスを追加または削除
    if (faqIcons[index].classList.contains("is-rotate")) {
      faqIcons[index].classList.remove("is-rotate");
    } else {
      faqIcons[index].classList.add("is-rotate");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // ページの読み込みが完了したら実行

  // ファストクリックイベントリスナーを設定
  var faqLinks = document.querySelectorAll(".FaqSummary__Link");
  faqLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // リンクのデフォルトの動作を無効化

      var targetId = this.getAttribute("href").substring(1); // リンクのhrefから対象要素のIDを取得
      var targetElement = document.getElementById(targetId); // 対象要素を取得
      var offset = parseInt(this.getAttribute("data-offset")) || 0; // オフセットを取得

      if (targetElement) {
        // スクロール先の座標を計算
        var offsetTop =
          targetElement.getBoundingClientRect().top + window.scrollY - offset;

        // スムーズなスクロールを実行
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    });
  });
});
